import React from 'react';
import { InappmessagesProps, fallbackImage } from '../inappmessages';
import { BodyContent } from './bodyContent';
import { Picture } from '../../../elements/picture/picture';

import styles from '../inappmessages.module.scss';
import classNames from 'classnames';

export function InappmessageModalGraphic({
  data,
  onClosePopup,
}: {
  data: InappmessagesProps;
  onClosePopup: Function;
}) {
  const { imageUrl, extras, buttons, openTarget, imageStyle } = data;
  const hideGradient = extras.hideGradient !== undefined && extras.hideGradient === 'true';

  return (
    <main className={classNames(styles.modalGraphic, (!hideGradient ? styles.modalGraphicGrdient : ''))}>
      <Picture
        className={styles.modalGraphicImage}
        sizes={[{ url: imageUrl }]}
        lazyLoad={true}
        isAMP={false}
        fallback={fallbackImage}
      ></Picture>
      <div className={styles.contentWrapper}>
        <BodyContent
          title={extras.Title || ''}
          description={extras.Description || ''}
          category={extras.Category || ''}
          buttons={buttons}
          openTarget={openTarget}
          imageStyle={imageStyle}
          onClosePopup={onClosePopup}
          inAppMessage={data}
        />
      </div>
    </main>
  );
}
